/**
 * --------------------------------------------------
 * !!! THIS FILE WAS GENERATED BY GRAPHQL-CODEGEN !!!
 * !!!   DO NOT MODIFY THIS FILE BY YOURSELF      !!!
 * --------------------------------------------------
 */

import * as c from "@hex/common";
import type * as Types from "../generated/graphqlTypes";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type FetchSnowflakeAccessTokenForSuccessViewMutationVariables =
  Types.Exact<{
    code: Types.Scalars["String"]["input"];
    state: Types.Scalars["String"]["input"];
  }>;

export type FetchSnowflakeAccessTokenForSuccessViewMutation = {
  readonly __typename: "Mutation";
  readonly fetchSnowflakeAccessToken: {
    readonly __typename: "SnowflakeOAuthConnection";
    readonly id: c.SnowflakeOAuthConnectionId;
    readonly linkedDataConnections: ReadonlyArray<{
      readonly __typename: "DataConnection";
      readonly id: c.DataConnectionId;
    }>;
  };
};

export type GetSnowflakeOAuthConnectionByIdQueryVariables = Types.Exact<{
  snowflakeOAuthConnectionId: Types.Scalars["SnowflakeOAuthConnectionId"]["input"];
}>;

export type GetSnowflakeOAuthConnectionByIdQuery = {
  readonly __typename: "Query";
  readonly getSnowflakeOAuthConnectionById: {
    readonly __typename: "SnowflakeOAuthConnection";
    readonly id: c.SnowflakeOAuthConnectionId;
    readonly linkedDataConnections: ReadonlyArray<{
      readonly __typename: "DataConnection";
      readonly id: c.DataConnectionId;
    }>;
  };
};

export const FetchSnowflakeAccessTokenForSuccessViewDocument = /*#__PURE__*/ gql`
  mutation FetchSnowflakeAccessTokenForSuccessView(
    $code: String!
    $state: String!
  ) {
    fetchSnowflakeAccessToken(code: $code, state: $state) {
      id
      linkedDataConnections {
        id
      }
    }
  }
`;
export type FetchSnowflakeAccessTokenForSuccessViewMutationFn =
  Apollo.MutationFunction<
    FetchSnowflakeAccessTokenForSuccessViewMutation,
    FetchSnowflakeAccessTokenForSuccessViewMutationVariables
  >;

/**
 * __useFetchSnowflakeAccessTokenForSuccessViewMutation__
 *
 * To run a mutation, you first call `useFetchSnowflakeAccessTokenForSuccessViewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFetchSnowflakeAccessTokenForSuccessViewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [fetchSnowflakeAccessTokenForSuccessViewMutation, { data, loading, error }] = useFetchSnowflakeAccessTokenForSuccessViewMutation({
 *   variables: {
 *      code: // value for 'code'
 *      state: // value for 'state'
 *   },
 * });
 */
export function useFetchSnowflakeAccessTokenForSuccessViewMutation(
  baseOptions?: Apollo.MutationHookOptions<
    FetchSnowflakeAccessTokenForSuccessViewMutation,
    FetchSnowflakeAccessTokenForSuccessViewMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    FetchSnowflakeAccessTokenForSuccessViewMutation,
    FetchSnowflakeAccessTokenForSuccessViewMutationVariables
  >(FetchSnowflakeAccessTokenForSuccessViewDocument, options);
}
export type FetchSnowflakeAccessTokenForSuccessViewMutationHookResult =
  ReturnType<typeof useFetchSnowflakeAccessTokenForSuccessViewMutation>;
export type FetchSnowflakeAccessTokenForSuccessViewMutationResult =
  Apollo.MutationResult<FetchSnowflakeAccessTokenForSuccessViewMutation>;
export type FetchSnowflakeAccessTokenForSuccessViewMutationOptions =
  Apollo.BaseMutationOptions<
    FetchSnowflakeAccessTokenForSuccessViewMutation,
    FetchSnowflakeAccessTokenForSuccessViewMutationVariables
  >;
export const GetSnowflakeOAuthConnectionByIdDocument = /*#__PURE__*/ gql`
  query GetSnowflakeOAuthConnectionById(
    $snowflakeOAuthConnectionId: SnowflakeOAuthConnectionId!
  ) {
    getSnowflakeOAuthConnectionById(
      snowflakeOAuthConnectionId: $snowflakeOAuthConnectionId
    ) {
      id
      linkedDataConnections {
        id
      }
    }
  }
`;

/**
 * __useGetSnowflakeOAuthConnectionByIdQuery__
 *
 * To run a query within a React component, call `useGetSnowflakeOAuthConnectionByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSnowflakeOAuthConnectionByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSnowflakeOAuthConnectionByIdQuery({
 *   variables: {
 *      snowflakeOAuthConnectionId: // value for 'snowflakeOAuthConnectionId'
 *   },
 * });
 */
export function useGetSnowflakeOAuthConnectionByIdQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetSnowflakeOAuthConnectionByIdQuery,
    GetSnowflakeOAuthConnectionByIdQueryVariables
  > &
    (
      | {
          variables: GetSnowflakeOAuthConnectionByIdQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetSnowflakeOAuthConnectionByIdQuery,
    GetSnowflakeOAuthConnectionByIdQueryVariables
  >(GetSnowflakeOAuthConnectionByIdDocument, options);
}
export function useGetSnowflakeOAuthConnectionByIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetSnowflakeOAuthConnectionByIdQuery,
    GetSnowflakeOAuthConnectionByIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetSnowflakeOAuthConnectionByIdQuery,
    GetSnowflakeOAuthConnectionByIdQueryVariables
  >(GetSnowflakeOAuthConnectionByIdDocument, options);
}
// @ts-ignore
export function useGetSnowflakeOAuthConnectionByIdSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetSnowflakeOAuthConnectionByIdQuery,
    GetSnowflakeOAuthConnectionByIdQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetSnowflakeOAuthConnectionByIdQuery,
  GetSnowflakeOAuthConnectionByIdQueryVariables
>;
export function useGetSnowflakeOAuthConnectionByIdSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetSnowflakeOAuthConnectionByIdQuery,
        GetSnowflakeOAuthConnectionByIdQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetSnowflakeOAuthConnectionByIdQuery | undefined,
  GetSnowflakeOAuthConnectionByIdQueryVariables
>;
export function useGetSnowflakeOAuthConnectionByIdSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetSnowflakeOAuthConnectionByIdQuery,
        GetSnowflakeOAuthConnectionByIdQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetSnowflakeOAuthConnectionByIdQuery,
    GetSnowflakeOAuthConnectionByIdQueryVariables
  >(GetSnowflakeOAuthConnectionByIdDocument, options);
}
export type GetSnowflakeOAuthConnectionByIdQueryHookResult = ReturnType<
  typeof useGetSnowflakeOAuthConnectionByIdQuery
>;
export type GetSnowflakeOAuthConnectionByIdLazyQueryHookResult = ReturnType<
  typeof useGetSnowflakeOAuthConnectionByIdLazyQuery
>;
export type GetSnowflakeOAuthConnectionByIdSuspenseQueryHookResult = ReturnType<
  typeof useGetSnowflakeOAuthConnectionByIdSuspenseQuery
>;
export type GetSnowflakeOAuthConnectionByIdQueryResult = Apollo.QueryResult<
  GetSnowflakeOAuthConnectionByIdQuery,
  GetSnowflakeOAuthConnectionByIdQueryVariables
>;
